import {ServiceOrderDeliverWorkForm} from "../../../../../../../../../../service-feature/useCases/deliver-work/form";

export function ServiceOrderWorkDeliveryDeliverWorkForm() {
  return <ServiceOrderDeliverWorkForm />;
}
